import React, { useState, useContext, useEffect } from "react";
import FInputt from "../../components/FInputt/FInputt";
import { useGroup } from "../../hooks/useGroups";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useContacts } from "../../hooks/useContacts";
import { useFormat } from "../../hooks/useFormat";
import { AuthContext } from "../../context/AuthContext";
import FContainer from "../../components/FContainer/FContainer";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import FInputText from "../../components/Finputs/FInputText/FInputText";
import * as Yup from "yup";
import Compress from "react-image-file-resizer";
import Swal from "sweetalert2";

const CreateGroupScreen = ({ param }) => {
  const route = useNavigate();
  const { state } = useLocation();
  const [image, setImage] = useState(
    "https://dev-app.tufiado.com/user/resources/add-image.png"
  );
  const [srcFileZoneSideBar, setSrcFileZoneSideBar] = useState();
  const { setAlert } = useContext(AuthContext);
  const { getBase64 } = useFormat();

  const { postGroup } = useGroup();

  const nextScreen = async ({ name, description, picture, members }) => {
    if ((await postGroup({ name, description, picture, members })) === true) {
      const next = () => {
        route("/GroupScreen");
      };

      Swal.fire({
        showCloseButton: true,
        title: 'Éxito',
        text: "Se ha creado tu grupo",
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        // iconColor: "#fd6e0d",
        confirmButtonText: 'Entendido'
      }).then((result) => {
        if (result.isConfirmed) {
          next();
        } else{
          next();
        }
      })

    } else {
      Swal.fire({
        showCloseButton: true,
        title: 'Advertencia',
        text: "No se pudo crear tu grupo",
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        iconColor: "#fd6e0d",
        confirmButtonText: 'Entendido'
      })
    }
  };
  const validate = Yup.object({
    name: Yup.string().required("Ingresa tu nombre"),
    description: Yup.string().required("Ingresa una descripción al grupo"),
  });

  const { getFirstLetter, aleatory3colors, getTwoWords } = useContacts();

  const [aleatory3colorss, setaleatory3colorss] = useState("");
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    setaleatory3colorss(aleatory3colors());
    setContacts(state.newContacts);
  }, []);

  const createGroupFormik = useFormik({
    initialValues: {
      name: "",
      description: "",
      picture: null,
      members: state.members,
    },
    onSubmit: async (values) => {
      const { name, description, members } = values;
      let img = image.replace("data:image/png;base64,", "");
      nextScreen({ name, description, picture: img, members });
    },
    validationSchema: validate,
  });

  const onFileResize = e => {
  const file = e.target.files[0];

  Compress.imageFileResizer(
      file, // the file from input
      480, // width
      480, // height
      "JPEG", // compress format WEBP, JPEG, PNG
      70, // quality
      0, // rotation
      (uri) => {
        setImage(uri);
        createGroupFormik.setFieldValue('picture', uri)
        setSrcFileZoneSideBar(uri);
      },
      "base64" // blob or base64 default base64
    );
  };

  return (
    <>
      <FContainer>
        <div className="border-0 w-full grid place-items-center">
          <label className="cursor-pointer rounded-lg">
            <img
              className="inline-block h-28 w-28 sm:h-48 sm:w-48"
              src={!srcFileZoneSideBar ? image : srcFileZoneSideBar}
            />
            <input
              type="file"
              id="file"
              className="hidden"
              onChange={onFileResize}
              accept="image/png, image/gif, image/jpeg"
            />
          </label>
        </div>
        <FInputText
          placeholder="Ej: Mi familia"
          title="Nombre del grupo"
          onChange={(value) => {
            createGroupFormik.setFieldValue("name", value);
          }}
          errorMessage={createGroupFormik.values.name == "" ? "" : createGroupFormik.errors.name}
        />
        <FInputText
          placeholder="Descripción"
          title="Descripción"
          onChange={(value) => {
            createGroupFormik.setFieldValue("description", value);
          }}
          errorMessage={createGroupFormik.values.description == "" ? "" : createGroupFormik.errors.description}
        />

        <div className="border-0 w-full text-center font-bold text-[4vw] smm:text-[18px] xxs:text-[14px] py-5">
          Lista de contactos
        </div>
        <div className="mt-5 flex content-center  items-center  bg-stripes-sky text-center h-28 p-1 justify-start  overflow-y-hidden overflow-x-scroll">
          {contacts?.length > 0
            ? contacts.map((contact, index) => (
                <div className="p-2 border-0 grid place-items-center">
                  <div>
                    <div
                      style={{ backgroundColor: aleatory3colorss }}
                      className={`shadow-lg rounded-full h-[60px] w-[60px] font-bold flex flex-col justify-center`}
                    >
                      <div className="text-white text-xl">
                        {getFirstLetter(contact.name)}
                      </div>
                    </div>
                  </div>
                  <div className="border-0">{getTwoWords(contact.name)}</div>
                </div>
              ))
            : null}
        </div>

        <Fbutton
          value={"Crear"}
          disabled={!(createGroupFormik.isValid && createGroupFormik.dirty)}
          onClick={createGroupFormik.handleSubmit}
        />
      </FContainer>
    </>
  );
};

export default CreateGroupScreen;
